export default __webpack_public_path__ + "static/media/gallery-runes_01.68282f70.jpg";